import { useEffect, useMemo } from 'react';
import { useGlobalState } from '@creditas/global-store';
import { showToast } from '@creditas-ui/react';
import i18n from '@/i18n';
import { useWindowResize } from '@/hooks/helpers/useWindowResize';
import { useGetAccountInformation } from '@/hooks/queries/useGetAccountInformation';
import { dispatchToasterEvent } from '@/utils/analyticsEvents/toasterEvents';
import { HeaderMobile } from './HeaderMobile';
import { HeaderDesktop } from './HeaderDesktop';

const Header = (): JSX.Element => {
  const state = useGlobalState();
  const searchParams = useMemo(() => new URLSearchParams(document.location.search), []);
  const { data, isLoading } = useGetAccountInformation();
  const { isMobile } = useWindowResize();
  const toasterTextMessage = i18n.t('header:redirected_lead');
  const headerProps = {
    label: data?.screenName || '',
  };

  useEffect(() => {
    if (!isLoading) {
      state.dashboardLoader.toggleHeader();
    }
  }, [isLoading, state.dashboardLoader]);

  useEffect(() => {
    const showActiveLeadMessage = searchParams.get('active_lead');
    if (showActiveLeadMessage) {
      showToast(toasterTextMessage, {
        variant: 'dark',
        emoji: {
          symbol: '😕',
          label: 'confuso',
        },
        duration: 5000,
        onClose: () => {
          dispatchToasterEvent('closed', toasterTextMessage);
        },
        position: 'top-center',
      });
      dispatchToasterEvent('displayed', toasterTextMessage);
    }
  }, [searchParams, toasterTextMessage]);

  return isMobile ? <HeaderMobile {...headerProps} /> : <HeaderDesktop {...headerProps} />;
};

export { Header };
